import { type StateCreator } from 'zustand';

export type MainSideNavPinSlice = {
  pinned: boolean;
  setPinned: (pinned: boolean) => void;
  setSuppressPinned: (suppressPinned: boolean) => void;
  suppressPinned: boolean;
  togglePinned: () => void;
};

export type CreateMainSideNavPinSlice = (
  initialState: Pick<Partial<MainSideNavPinSlice>, 'pinned' | 'suppressPinned'>,
) => StateCreator<MainSideNavPinSlice, [], [], MainSideNavPinSlice>;

export const createMainSideNavPinSlice: CreateMainSideNavPinSlice = (initialState) => (set) => ({
  pinned: initialState.pinned ?? false,
  setPinned: (pinned) => set({ pinned }),
  setSuppressPinned: (suppressPinned) => set({ suppressPinned }),
  suppressPinned: initialState.suppressPinned ?? false,
  togglePinned: () => set((state) => ({ pinned: !state.pinned })),
});
